import { Link, useParams } from 'react-router-dom';
import { useSidebar } from '@/context/SidebarContext';
import { useFolders } from '@/hooks/useFolders';
import FolderList from '@/components/folder/FolderList';
import styles from './Sidebar.module.css';

export default function Sidebar() {
  const { isOpen, isMobile, close } = useSidebar();
  const { folderId } = useParams();
  const { folders, isLoading } = useFolders();

  const handleNavigation = () => {
    if (isMobile) {
      close();
    }
  };

  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
      <div className={styles.header}>
        <h2 className={styles.title}>Folders</h2>
      </div>

      <nav className={styles.nav}>
        <Link
          to="/app/folder/all"
          className={`${styles.navLink} ${folderId === 'all' ? styles.active : ''}`}
          onClick={handleNavigation}
        >
          All Recipes
        </Link>

        <FolderList
          folders={folders}
          isLoading={isLoading}
          activeFolderId={folderId}
          onNavigate={handleNavigation}
        />
      </nav>
    </aside>
  );
}
